"use client";
import {
  QueryClient,
  QueryClientProvider,
  defaultShouldDehydrateQuery,
  isServer,
} from "@tanstack/react-query";
import ms from "ms";
import { type ComponentProps, useState } from "react";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: ms("5m"),
        retry: 0,
      },
      dehydrate: {
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
      },
    },
  });
}

export let client: QueryClient;

function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  }

  if (!client) client = makeQueryClient();
  return client;
}

type Props = {} & Omit<ComponentProps<typeof QueryClientProvider>, "client">;

export const QueryProvider = ({ children, ...props }: Props) => {
  const [client] = useState(() => getQueryClient());

  return (
    <QueryClientProvider {...props} client={client}>
      {children}
      {/* {!isProd() && <ReactQueryDevtools initialIsOpen={false} />} */}
    </QueryClientProvider>
  );
};
